var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"user_step"},_vm._l((_vm.userStep),function(step,idx){return _c('li',{key:idx,class:step.class},[_c('div',[_c('span',[_vm._v(_vm._s(idx + 1))]),_c('p',[_vm._v(_vm._s(step.step))])]),_c('b-icon',{attrs:{"icon":"chevron-double-down"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }